import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { RoleAssignmentDTOBase } from "./RoleAssignmentDTOBase";
import type { RoleRef } from "./RoleRef";
import type { RoleStaff } from "./RoleStaff";
import type { UserStaff } from "./UserStaff";

export class RoleAssignmentStaff implements RoleAssignmentDTOBase {
  constructor(public readonly roleAssignmentId: number, public readonly userId: UserStaff | null, public readonly roleId: RoleStaff | null, public readonly assignedBy: UserStaff | null, public readonly assignedOn: Date, public readonly roleIdTargetIds: RoleRef) {
    this.cbiServiceContext = null;
    this.userIdLoaded = this.userId != null;
    this.userIdCached = this.userId;
    this.roleIdLoaded = this.roleId != null;
    this.roleIdCached = this.roleId;
    this.assignedByLoaded = this.assignedBy != null;
    this.assignedByCached = this.assignedBy;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private userIdLoaded: boolean;
  private userIdCached: UserStaff | null;
  private roleIdLoaded: boolean;
  private roleIdCached: RoleStaff | null;
  private assignedByLoaded: boolean;
  private assignedByCached: UserStaff | null;
  async userIdLazy(): Promise<UserStaff> {
    if (!this.userIdLoaded) {
      this.userIdCached = await this.cbiServiceContext!.permissionService().getRoleAssignmentStaffUserId(this.roleAssignmentId);
      this.userIdLoaded = true;
    }
    return this.userIdCached!;
  }
  async roleIdLazy(): Promise<RoleStaff> {
    if (!this.roleIdLoaded) {
      this.roleIdCached = await this.cbiServiceContext!.permissionService().getRoleStaff(this.roleIdTargetIds.roleId);
      this.roleIdLoaded = true;
    }
    return this.roleIdCached!;
  }
  async assignedByLazy(): Promise<UserStaff> {
    if (!this.assignedByLoaded) {
      this.assignedByCached = await this.cbiServiceContext!.permissionService().getRoleAssignmentStaffAssignedBy(this.roleAssignmentId);
      this.assignedByLoaded = true;
    }
    return this.assignedByCached!;
  }
}
